(function () {
  'use strict';

  var configElement = document.getElementById('BxgyFreeGiftConfig');
  if (!configElement) return;

  var config;
  try {
    config = JSON.parse(configElement.textContent);
  } catch (error) {
    console.warn('BXGY free gift config could not be parsed.', error);
    return;
  }

  if (!Array.isArray(config.offers)) return;

  var giftMarker = '_bxgy_free_gift';
  var offerMarker = '_bxgy_offer_id';
  var utils = window.CartGiftUtils;
  if (!utils || !window.CartGiftRuntime) return;
  var configuredOffers = config.offers.filter(isConfiguredOffer).map(normalizeOffer);
  var activeOffers = [];
  var activeOfferIds = [];
  var currentCollectionId = config.currentCollectionId ? String(config.currentCollectionId) : '';
  var pendingAddOfferIds = {};
  var lastAddFailureByOffer = {};
  var addFailureCooldown = 30000;

  function isConfiguredOffer(offer) {
    return Boolean(
      offer &&
      offer.enabled &&
      offer.id &&
      offer.gift &&
      offer.gift.variantId &&
      Array.isArray(offer.qualifierProductIds) &&
      offer.qualifierProductIds.length
    );
  }

  function refreshActiveOffers() {
    activeOffers = configuredOffers.filter(function (offer) {
      return offer.schedule.state().active;
    });
    activeOfferIds = activeOffers.map(function (offer) {
      return offer.id;
    });
  }

  function normalizeOffer(offer) {
    var requiredCollectionId = offer.requiredCollectionId ? String(offer.requiredCollectionId) : '';
    var schedule = offer.schedule || {};

    return {
      id: String(offer.id),
      name: offer.name || offer.id,
      qualifierProductIds: offer.qualifierProductIds.map(String),
      requiredCollectionId: requiredCollectionId,
      schedule: utils.createSchedule(schedule.start, schedule.end, config.scheduleTimeZone),
      giftProductId: String(offer.gift.productId),
      giftVariantId: Number(offer.gift.variantId),
      giftQuantity: Math.max(1, Number(offer.giftQuantity) || 1),
      giftProperties: Object.assign({}, offer.giftProperties || {}, {
        '_bxgy_free_gift': 'true',
        '_bxgy_offer_id': String(offer.id)
      })
    };
  }

  function getProperties(item) {
    return item && item.properties ? item.properties : {};
  }

  function hasGiftMarker(item) {
    return getProperties(item)[giftMarker] === 'true';
  }

  function getOfferId(item) {
    return String(getProperties(item)[offerMarker] || '');
  }

  function isManagedGiftItem(item) {
    return hasGiftMarker(item);
  }

  function isQualifierItemForOffer(item, offer) {
    if (!item || utils.isGift(item)) return false;
    return offer.qualifierProductIds.indexOf(String(item.product_id)) !== -1;
  }

  function getQualifierQuantityForOffer(items, offer) {
    return items.reduce(function (quantity, item) {
      if (!isQualifierItemForOffer(item, offer)) return quantity;
      return quantity + Math.max(0, Number(item.quantity) || 0);
    }, 0);
  }

  function isCurrentGiftItemForOffer(item, offer) {
    if (!isManagedGiftItem(item)) return false;
    if (getOfferId(item) !== offer.id) return false;
    return String(item.product_id) === offer.giftProductId || Number(item.variant_id) === offer.giftVariantId;
  }

  function updateOfferCallouts() {
    document.querySelectorAll('[data-bxgy-offer-id]').forEach(function (callout) {
      var offerId = String(callout.getAttribute('data-bxgy-offer-id') || '');
      callout.hidden = activeOfferIds.indexOf(offerId) === -1;
    });

    document.querySelectorAll('[data-bxgy-callouts]').forEach(function (calloutGroup) {
      calloutGroup.hidden = !calloutGroup.querySelector('[data-bxgy-offer-id]:not([hidden])');
    });
  }

  function getAddedItems(payload) {
    if (!payload || typeof payload !== 'object') return [];
    return Array.isArray(payload.items) ? payload.items : [payload];
  }

  function allowGatedOffersForCartAdd(payload) {
    refreshActiveOffers();
    var addedProductIds = getAddedItems(payload).map(function (item) {
      return item && item.product_id ? String(item.product_id) : '';
    }).filter(Boolean);

    activeOffers.forEach(function (offer) {
      if (!offer.requiredCollectionId || offer.requiredCollectionId !== currentCollectionId) return;

      var addedQualifier = !addedProductIds.length || addedProductIds.some(function (productId) {
        return offer.qualifierProductIds.indexOf(productId) !== -1;
      });

      if (addedQualifier) pendingAddOfferIds[offer.id] = true;
    });
  }

  function canAddGift(offer, allowedOfferIds) {
    return !offer.requiredCollectionId || Boolean(allowedOfferIds[offer.id]);
  }

  async function reconcileCart(cart, api) {
    refreshActiveOffers();
    var allowedOfferIds = pendingAddOfferIds;
    pendingAddOfferIds = {};
    var updates = {};
    var increases = [];
    var kept = {};
    cart.items.filter(isManagedGiftItem).forEach(function (item) {
      var offer = activeOffers.find(function (candidate) { return candidate.id === getOfferId(item); });
      var quantity = offer && isCurrentGiftItemForOffer(item, offer) && !kept[offer.id]
        ? getQualifierQuantityForOffer(cart.items, offer) * offer.giftQuantity : 0;
      if (quantity) kept[offer.id] = true;
      if (quantity > item.quantity) increases.push({ offerId: offer.id, variantId: item.variant_id, quantity: quantity });
      else if (quantity !== item.quantity) updates[item.key] = quantity;
    });
    try {
      if (Object.keys(updates).length) cart = await api.update(updates);
      // update.js does not validate inventory for existing lines. Use change.js for
      // increases, resolving the current key after any discount-changing removals.
      for (var increase of increases) {
        var line = cart.items.find(function (item) {
          return isManagedGiftItem(item) && getOfferId(item) === increase.offerId && item.variant_id === increase.variantId;
        });
        if (line) {
          try { cart = await api.change(line.key, increase.quantity); }
          catch (error) {
            if (error.status !== 422) throw error;
            lastAddFailureByOffer[increase.offerId] = Date.now();
            cart = await api.getCart();
          }
        }
      }
      for (var i = 0; i < activeOffers.length; i++) {
        var offer = activeOffers[i];
        var quantity = getQualifierQuantityForOffer(cart.items, offer) * offer.giftQuantity;
        if (!quantity || !offer.schedule.state().active || !canAddGift(offer, allowedOfferIds)) continue;
        if (api.isGiftDismissed({ id: offer.giftVariantId, properties: offer.giftProperties })) continue;
        if (cart.items.some(function (item) { return isCurrentGiftItemForOffer(item, offer); })) continue;
        if (Date.now() - (lastAddFailureByOffer[offer.id] || 0) < addFailureCooldown) continue;
        try {
          await api.add([{ id: offer.giftVariantId, quantity: quantity, properties: offer.giftProperties }]);
        } catch (error) {
          if (error.status !== 422) throw error;
          lastAddFailureByOffer[offer.id] = Date.now();
          console.warn('BXGY free gift could not be added for ' + offer.name + '.', error);
        }
        cart = await api.getCart();
      }
      return cart;
    } catch (error) {
      Object.keys(allowedOfferIds).forEach(function (id) { pendingAddOfferIds[id] = true; });
      throw error;
    }
  }

  window.CartGiftRuntime.register({
    reconcile: reconcileCart,
    onAdd: allowGatedOffersForCartAdd,
    scheduleState: function () {
      refreshActiveOffers();
      updateOfferCallouts();
      return {
        key: activeOfferIds.join(','),
        future: configuredOffers.some(function (offer) { return offer.schedule.state().future; })
      };
    }
  });
})();
